import { render, staticRenderFns } from "./Routers.vue?vue&type=template&id=32cd63e4&scoped=true"
import script from "./Routers.vue?vue&type=script&lang=js"
export * from "./Routers.vue?vue&type=script&lang=js"
import style0 from "./Routers.vue?vue&type=style&index=0&id=32cd63e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd63e4",
  null
  
)

export default component.exports